import BgHome from "../../assets/bgHome.svg";

export const divStyle = {
    position: "fixed",
    backgroundSize: "cover",
    backgroundImage: `url(${BgHome})`,
    width: "100%",
    height: "100%",
};
